import * as React from "react";
import { TModuleProps } from "../../../services/playground";
import { TBannerItem } from "../../../services/banner";

import { NavContainer, TitleBox } from "./style";

export interface PCLitbNavProps extends TModuleProps {
	navModules: TBannerItem[];
}

const PCLitbNav: any = (props: PCLitbNavProps) => {
	const { positionId, navModules, stickToTop } = props;
	const onScroll = (link: string) => () => {
		const linkID: string = link.substr(1);
		let dom: HTMLElement | null = document.getElementById(linkID);
		dom?.scrollIntoView({ block: "start" });
		setTimeout(() => {
			window.scrollBy(0, -(stickToTop ? stickToTop : 0));
		}, 0);
	};
	return (
		<section id={positionId}>
			<NavContainer>
				{navModules.map((ele, index) => {
					return (
						<a key={index} onClick={onScroll(ele.link)}>
							<TitleBox
								color={ele.bgColor === ("#ffffff" || "#fff") ? "#666" : "#fff"}
								bgColor={ele.bgColor || "#fff"}
							>
								{ele.text}
							</TitleBox>
							<img src={ele.img} alt="" />
						</a>
					);
				})}
			</NavContainer>
		</section>
	);
};

export default PCLitbNav;
